import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {arrowSxDefault, CustomStyleImage, tooltipSxDefault} from "./Styles";
import Tooltip from '@mui/material/Tooltip';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description CustomImageTable
 * @param String buttonImg: Identifier for the image (required)
 * @param String text: Text for the label (required)
 * @param String image: Path image (required)
 * @param {JSX.Element} icon - (Optional) A React component or element to render as the icon instead of the image
 * @param Event click: Click trigger in image (optional)
 * @param String containerClass: String for class container, example: "class1 class2" (optional)
 * @param String tooltip: Text for the tooltip (optional)
 * @param {JSX.Element} children:  Elements that will be the content of the component (optional).
 * @param String placement: Position for tooltip (optional)
 * @returns {JSX.Element}
 */
const  CustomImageTable = ({isTooltip = false,buttonImg, text, image, icon, click, containerClass='', tooltip = '', children,
                               placement='left', classNameImage='',
                               tooltipSx = tooltipSxDefault,
                               arrowSx = arrowSxDefault
}) => {
    const elementRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    const [isComponent, setIsComponent] = useState(false);

    useEffect(() => {
        if(tooltip === '')  return;
        if(elementRef.current !== null){
            const spanElement = elementRef.current.querySelector('.text-ellipsis');
            if (spanElement) {
                let aux = spanElement.scrollWidth > spanElement.clientWidth;
                setIsTruncated(aux);
                if(!aux) spanElement.classList.remove("text-ellipsis");
            }
        }

    },[]);

    useLayoutEffect(() => {
        if(typeof image === 'function' || typeof image === 'object'){
            setIsComponent(true);
        }
    }, [image]);

    const RenderIconImage = ({ isComponent, Image, text, icon }) => {
        if (icon) return icon; // if it's a component, just return it
        if (!Image) return null;

        const style = CustomStyleImage(text);
        if (isComponent) {
            return <div><Image style={style} /></div>;
        } else {
            return <img src={Image} style={style} alt={text} className={classNameImage} />;
        }
    };

    return <>
       <span
           className={`${containerClass} ${click ? 'cursor-pointer' : '' }`}
           ref={elementRef}
           onClick={click ? click : undefined}
       >
            {click ?
                <a id={buttonImg} className={"btn-hover-transparent"}
                   onClick={(e) => {
                       e.stopPropagation();
                       click(e,image);
                   }}
                >
                    <RenderIconImage
                        isComponent={isComponent}
                        Image={image}
                        text={text}
                        icon={icon}
                    />
                </a>
                :
                <>
                    {
                        (isTooltip && tooltip) || isTruncated ?
                            <Tooltip title={tooltip} placement={placement} arrow={false} disableInteractive
                                     componentsProps={{
                                            tooltip: { sx: tooltipSx },
                                            arrow: { sx: arrowSx },
                                    }}>
                                <RenderIconImage
                                    isComponent={isComponent}
                                    Image={image}
                                    text={text}
                                    icon={icon}
                                />
                                {children}
                            </Tooltip>
                            :<>
                                <RenderIconImage
                                    isComponent={isComponent}
                                    Image={image}
                                    text={text}
                                    icon={icon}
                                />
                                {children}
                            </>
                    }
                </>
            }
            {text}
        </span>
    </>
}

export default CustomImageTable
